import React, { useEffect } from 'react';

const LoadingScreen = ({ onLoadingComplete }) => {
  useEffect(() => {
    // Set a timer to automatically transition to the voting screen after 3 seconds
    const timer = setTimeout(() => {
      onLoadingComplete();
    }, 3000);
    
    // Cleanup the timer when component unmounts
    return () => clearTimeout(timer);
  }, [onLoadingComplete]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-toon-yellow">
      {/* Toon House logo */}
      <div className="w-64 h-64 mb-8 flex items-center justify-center">
        <img src="/assets/Toon_House_Logo.svg" alt="Toon House Logo" className="w-full h-full" />
      </div>
      
      {/* Animated progress bar */}
      <div className="w-full max-w-md h-4 bg-white rounded-full overflow-hidden mt-8">
        <div className="h-full bg-green-500 animate-progress"></div>
      </div>
    </div>
  );
};

export default LoadingScreen;
